import React from "react";
import { motion } from "framer-motion";
import {
  DashboardMockup,
  DigitalMenuMockup,
  CheckoutMockup,
  OrderTrackingMockup,
  LiveOrderMockup,
  PhoneFrame,
} from "@/components/UiMockups";

const cards = [
  { id: "dash", title: "Restaurant Dashboard", Comp: DashboardMockup, phone: false, span: "md:col-span-7" },
  { id: "live", title: "Live Order Management", Comp: LiveOrderMockup, phone: false, span: "md:col-span-5" },
  { id: "menu", title: "Digital Menu", Comp: DigitalMenuMockup, phone: false, span: "md:col-span-4" },
  { id: "checkout", title: "Transparent Checkout", Comp: CheckoutMockup, phone: false, span: "md:col-span-4" },
  { id: "track", title: "Order Tracking", Comp: OrderTrackingMockup, phone: true, span: "md:col-span-4" },
];

export default function Mockups() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-5 lg:gap-6">
      {cards.map((c, i) => {
        const Comp = c.Comp;
        return (
          <motion.div
            key={c.id}
            data-testid={`mockup-card-${c.id}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className={`rounded-2xl border border-white/10 bg-gradient-to-b from-neutral-900 to-neutral-950 p-5 sm:p-6 flex flex-col ${c.span}`}
          >
            <div className="mb-4">
              <div className="text-[10px] uppercase tracking-[0.2em] text-orange-400 font-semibold">Product UI</div>
              <h3 className="font-display font-black text-white text-lg sm:text-xl mt-0.5">{c.title}</h3>
            </div>
            <div className="flex-1 flex items-center justify-center">
              {c.phone ? (
                <PhoneFrame>
                  <Comp />
                </PhoneFrame>
              ) : (
                <div className="w-full max-w-sm mx-auto">
                  <Comp />
                </div>
              )}
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
